// Import model
import { MenuItem } from '../models/MenuItem';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)
import { ActionMenuItemSerializer } from './ActionMenuItemSerializer';
import { MenuSerializer } from './MenuSerializer';
import { PageMenuItemSerializer } from './PageMenuItemSerializer';

/**
 * Serializer for MenuItem - handles JSON serialization and deserialization with type validation
 */
export class MenuItemSerializer {
  /**
   * Deserializes a JSON string into a MenuItem instance
   */
  static deserialize(json: string): MenuItem {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a MenuItem instance
   */
  static fromObject(obj: any): MenuItem {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to MenuItem');
    }

    // Handle polymorphic deserialization using discriminator
    const discriminator = obj['_t'];

    switch (discriminator) {
      case 'Menu':
        return MenuSerializer.fromObject(obj);
      case 'ActionMenuItem':
        return ActionMenuItemSerializer.fromObject(obj);
      case 'PageMenuItem':
        return PageMenuItemSerializer.fromObject(obj);
      default:
        // Fall through to base type deserialization
        break;
    }

    const instance: MenuItem = {
      icon: obj['Icon'] as string | undefined,
      t: obj['_t'] as string,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of MenuItem instances
   */
  static deserializeArray(json: string): MenuItem[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a MenuItem instance to a JSON string
   */
  static serialize(instance: MenuItem): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a MenuItem instance to a plain object
   */
  static toObject(instance: MenuItem): any {
    return {
      'Icon': instance.icon,
      '_t': instance.t,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of MenuItem instances to a JSON string
   */
  static serializeArray(instances: MenuItem[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
